import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedHttpService } from '../../services/shared-http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { CaseService } from '../../services/case.service';
import { PrintDesionService } from '../../services/print-decsion.service';

@Component({
  selector: 'app-decsion',
  templateUrl: './decsion.component.html',
  styleUrls: ['./decsion.component.scss']
})
export class DecsionComponent implements OnInit {
  @Input() loadDataFP: Observable<any>;
  caseObj:any;
  decsionObject:any;
    constructor(  public sharedService: SharedHttpService, public router: ActivatedRoute, public toastr: NotificationService, public route: Router, public caseService : CaseService,private printDecsion : PrintDesionService) { }
  ngOnInit(): void {
    this.decsionObject=undefined;
    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
        this.loadData();
      }, 100);


    });
  }
  loadData() {
    this.caseObj=this.caseService.getCaseData();
    this.sharedService.get(`api/Decsion/GetCaseDecsion?eCaseId=${this.caseObj.eCaseId}`).subscribe(res => {
      this.decsionObject=res;
    });
  }
    PrintDecision() {

       // console.log("--------------------------------------------------------");
       // console.log("--------------------------------------------------------");

    this.printDecsion.PrintDecisionWithoutAPI(this.decsionObject);
    //  this.printDecsion.PrintDecision(this.caseService.getCaseData().eCaseId);
  }

}
